'use client';
import { SelectedMenus, Template } from '@zeus/shared';
import { memo, useMemo } from 'react';
import Category from '../Category';
import { isBetweenRange } from '../../../../../utils/utils';

interface MenuProps {
  menu: SelectedMenus;
  template: Template;
  development?: boolean;
  menuIndex: number;
  timezone?: string;
  scale?: number;
}

const Menu = ({ menu, template, development, menuIndex, timezone, scale = 1 }: MenuProps) => {
  const categories = useMemo(() => menu.categories, [menu.categories]);
  const isDevelopment = development ? true : isBetweenRange(menu.schedules, timezone);
  //const fontFamily = extractFontFamilyFromUrl(template?.fontFamily);
  const fontFamily = template?.fontFamilyName;

  return (
    <>
      {isDevelopment &&
        categories.map((category, categoryIndex) => (
          <Category
            key={`${category.id}`}
            category={category}
            categoryIndex={categoryIndex}
            template={template}
            menuIndex={menuIndex}
            development={development}
            timezone={timezone}
            scale={scale}
            fontFamily={fontFamily}
          />
        ))}
    </>
  );
};

export default memo(Menu);
